export default [
  {
    path: '/newsletters',
    name: 'newsletters',
    component: () => import('@/views/pages/newsletter/List.vue'),
    meta: {
      pageTitle: 'breadcrumb.newsletters',
      resource: 'newsletter',
      action: 'list',
      breadcrumb: [
        {
          text: 'breadcrumb.list',
          active: true,
        },
      ],
    },
  },
  {
    path: '/newsletter/add',
    name: 'add-newsletter',
    component: () => import('@/views/pages/newsletter/Add.vue'),
    meta: {
      pageTitle: 'breadcrumb.newsletters',
      resource: 'newsletter',
      action: 'create',
      breadcrumb: [
        {
          text: 'breadcrumb.add',
          active: true,
        },
      ],
    },
  },
  {
    path: '/newsletter/modify/:id',
    name: 'modify-newsletter',
    component: () => import('@/views/pages/newsletter/Modify.vue'),
    meta: {
      pageTitle: 'breadcrumb.newsletters',
      resource: 'newsletter',
      action: 'edit',
      breadcrumb: [
        {
          text: 'breadcrumb.modify',
          active: true,
        },
      ],
    },
  },
]
